import styled from "styled-components";
import Sheet from "react-modal-sheet";

export const MobileSortItem = styled.li`
  padding: 1rem 1.5rem;
  text-align: right;
  direction: rtl;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: var(--gray-color);
  }

  &.active-sort {
    a {
      color: var(--dark-gray-color);
    }
  }

  &:nth-child(even) {
    background-color: #F6F7F9;
  }
  
  i.tick::before {
    color: var(--dark-gray-color);
  }
`;

export const CustomSheet = styled(Sheet)`
  .icon-close-circle::before {
      color: var(--dark-gray-color);
    font-size: 1.1rem;
  }
  
  .react-modal-sheet-container {
    border-radius: 20px 20px 0 0!important; 
  }
  
  .react-modal-sheet-backdrop {
    pointer-events: all!important;
  }
`;
